import React, { useContext, useEffect } from 'react';
import { Accordion, AccordionSummary, Typography, Grid, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from 'components/Table';
import { ReportContext } from 'providers/ReportProvider';
import { ModelsContext } from 'providers/ModelsProvider';
import { ENTITY_COMPANY, ENTITY_BANK, ENTITY_PRIVATE_COMPANY, TABLE_HEADERS } from 'constants';
import { parseIndicator } from 'utils';
import { ENTITY_SUPPLIER } from 'constants';

const EditorIncomeStatement = () => {
  const { report, period, entityType, income, setIncome } = useContext(ReportContext);
  const { incomeItems } = useContext(ModelsContext);

  const parseIncome = (values, entityType, period) => {
    let keys = [];
    const indicators = [];

    if (entityType === ENTITY_COMPANY) {
      keys = incomeItems.company.map((item) => item.code);
    } else if (entityType === ENTITY_BANK) {
      keys = incomeItems.bank.map((item) => item.code);
    } else if (entityType === ENTITY_PRIVATE_COMPANY) {
      keys = incomeItems.privateCompany.map((item) => item.code);
    } else if (entityType === ENTITY_SUPPLIER) {
      keys = incomeItems.supplier.map((item) => item.code);
    }

    keys.forEach((key, index) => {
      const indicator = values[key];

      indicators.push({
        id: index,
        field: indicator.metadata.name,
        value: parseIndicator(indicator, period),
        code: key,
        indicatorId: indicator.metadata.id,
      });
    });
    return indicators;
  };

  const handleOnChange = (event, id) => {
    const temp = [...income];
    temp[id].value = event.target.value;
    setIncome(temp);
  };

  useEffect(() => {
    if (entityType === ENTITY_COMPANY) setIncome(incomeItems.company);
  }, [entityType, incomeItems, setIncome]);

  useEffect(() => {
    if (!report) return;

    const { indicators, type } = report;
    const res = parseIncome(indicators, type, period);
    setIncome(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [report, period]);

  useEffect(() => {
    if (report) return;

    if (entityType === ENTITY_BANK) {
      setIncome(incomeItems.bank);
    }

    if (entityType === ENTITY_COMPANY) {
      setIncome(incomeItems.company);
    }

    if (entityType === ENTITY_PRIVATE_COMPANY) {
      setIncome(incomeItems.privateCompany);
    }

    if (entityType === ENTITY_SUPPLIER) {
      setIncome(incomeItems.supplier);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, report]);

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Income Statement</Typography>
      </AccordionSummary>

      <Divider />

      <Grid container padding={2} gap={2}>
        {income && <Table headers={TABLE_HEADERS} rows={income} onChange={handleOnChange} />}
      </Grid>
    </Accordion>
  );
};

export default EditorIncomeStatement;
